import { useSuspenseQuery } from "@tanstack/react-query";
import { Suspense } from "react";
import { Link, createFileRoute } from "@tanstack/react-router";
import { type } from "arktype";
import { ArrowLeft } from "lucide-react";

import { orpc } from "@/client";
import { ErrorBoundary } from "@/components/error-boundary";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { Skeleton } from "@/components/ui/skeleton";

import { CadastroForm } from "./-components/cadastro-form";

const paramsSchema = type({ id: "string.integer.parse | number.integer" });

export const Route = createFileRoute("/_app/cadastro/$id")({
	params: {
		parse: (raw) => paramsSchema.assert(raw),
		stringify: ({ id }) => ({ id: String(id) }),
	},
	component: CadastroEditPage,
});

function CadastroEditPage() {
	const { id } = Route.useParams();

	return (
		<PageContainer>
			<div className="mb-6">
				<Link
					to="/pessoa/$id"
					params={{ id }}
					className="inline-flex items-center gap-1.5 rounded-md text-sm font-medium text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
				>
					<ArrowLeft className="size-4" />
					Ficha
				</Link>
			</div>

			<PageHeader title="Editar cadastro" />

			<ErrorBoundary fallback={<CadastroError id={id} />}>
				<Suspense fallback={<CadastroSkeleton />}>
					<CadastroData id={id} />
				</Suspense>
			</ErrorBoundary>
		</PageContainer>
	);
}

function CadastroData({ id }: { id: number }) {
	const { data } = useSuspenseQuery(orpc.people.detail.queryOptions({ input: { id } }));

	if (data === null) {
		return <p className="text-sm text-muted-foreground">Pessoa #{id} não encontrada.</p>;
	}

	return <CadastroForm person={data} />;
}

function CadastroError({ id }: { id: number }) {
	return <p className="text-sm text-destructive">Não foi possível carregar a pessoa #{id}.</p>;
}

function CadastroSkeleton() {
	return (
		<div className="flex flex-col gap-4">
			<Skeleton className="h-40 w-full" />
			<Skeleton className="h-40 w-full" />
		</div>
	);
}
